exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headline[data-v-2f6d19d5] {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2f6d19d5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/employees/learning/components/pie.vue
// module id = 559
// module chunks = 0